import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCommentRatingShow, trackRatingSend, trackStarsRatingShow } from './tracking';
import { closeFeedbackChatbotModal, setFeedback } from '../../actions/feedbackChatbotModal';
import { FeedbackChatbotModal } from '../../components/FeedbackChatbotModal/FeedbackChatbotModal';
import { feedbackChatbotModalSelector } from '../../selectors/feedbackChatbotModalSelector';
import { startPollingMessages, stopPollingMessages } from '../../thunks/chatbot';
import { setCloseRating } from '../../thunks/chatbot/feedback/setCloseRating';
import { setRating } from '../../thunks/chatbot/feedback/setRaiting';
import { ETelemetryEvents } from '../../types/telemetry';
import { useApplicationContext } from '../../utils/applicationContext';

export const FeedbackChatbotModalContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const { telemetry } = useApplicationContext();
  const { isOpened, rating, comment } = useSelector(feedbackChatbotModalSelector);
  const [showFeedbackComment, setShowFeedbackComment] = React.useState(false);

  const prevIsOpened = React.useRef<boolean | null>(null);

  React.useEffect(() => {
    if (isOpened) {
      if (rating === 0) {
        dispatch(stopPollingMessages());
        telemetry.increment(ETelemetryEvents.FeedbackChatbotModalShow);
        trackStarsRatingShow();
      } else if (showFeedbackComment) {
        trackCommentRatingShow();
      }
    } else {
      if (prevIsOpened.current === true) {
        dispatch(startPollingMessages({ isQuick: true }));

        if (rating !== 0) {
          telemetry.increment(ETelemetryEvents.FeedbackChatbotModalRating);
          trackRatingSend(rating, comment);
          dispatch(setRating(rating, comment));
        }
      }
    }
    prevIsOpened.current = isOpened;
  }, [isOpened, rating, comment, showFeedbackComment, dispatch]);

  const onCancel = React.useCallback(() => {
    telemetry.increment(ETelemetryEvents.FeedbackChatbotModalHide);
    dispatch(setCloseRating());
    dispatch(closeFeedbackChatbotModal());
    dispatch(setFeedback(0));
  }, [dispatch]);

  if (!isOpened) {
    return null;
  }

  return (
    <FeedbackChatbotModal
      showFeedbackComment={showFeedbackComment}
      setShowFeedbackComment={setShowFeedbackComment}
      onCancel={onCancel}
    />
  );
};
